/* Scoped enhancements for Avone's existing controls. No third-party widgets. */
(() => {
  'use strict';
  const setup = () => {
    const html = document.documentElement;
    const search = document.querySelector('.search-drawer');
    let searchOpener = null;
    document.querySelectorAll('.searchIcn').forEach(opener => {
      opener.setAttribute('aria-controls', 'AccessibleSearchDrawer');
      opener.setAttribute('aria-expanded', 'false');
      opener.addEventListener('click', () => { searchOpener = opener; });
    });
    if (search) {
      const close = () => {
        html.classList.remove('searchact');
        if (searchOpener?.isConnected) searchOpener.focus();
      };
      search.querySelector('.close-search')?.addEventListener('click', close);
      search.addEventListener('keydown', e => {
        if (e.key === 'Escape') { e.preventDefault(); close(); }
      });
      const sync = () => {
        const open = html.classList.contains('searchact');
        if (!open && search.contains(document.activeElement)) searchOpener?.focus();
        search.inert = !open;
        document.querySelectorAll('.searchIcn').forEach(opener => opener.setAttribute('aria-expanded', String(open)));
      };
      new MutationObserver(sync).observe(html, {attributes:true, attributeFilter:['class']});
      sync();
    }
    document.querySelector('.skip-to-content-link')?.addEventListener('click', () => {
      document.getElementById('PageContainer')?.focus();
    });
    document.querySelectorAll('#main-nav li').forEach((item, index) => {
      const trigger = item.querySelector(':scope > a');
      const panel = item.querySelector(':scope > ul.ddmenu, :scope > div.mgmenu');
      if (!trigger || !panel) return;
      panel.id ||= `a11y-navigation-${index}`;
      trigger.setAttribute('aria-controls', panel.id);
      const sync = () => trigger.setAttribute('aria-expanded', String(
        !item.classList.contains('a11y-menu-dismissed') &&
        (item.contains(document.activeElement) || item.matches(':hover'))
      ));
      item.addEventListener('focusin', e => {
        if (!item.contains(e.relatedTarget)) item.classList.remove('a11y-menu-dismissed');
        sync();
      });
      item.addEventListener('focusout', () => requestAnimationFrame(sync));
      item.addEventListener('mouseenter', () => { item.classList.remove('a11y-menu-dismissed'); sync(); });
      item.addEventListener('mouseleave', sync);
      trigger.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown' || (trigger.getAttribute('href') === '#' && ['Enter',' '].includes(e.key))) {
          e.preventDefault();
          item.classList.remove('a11y-menu-dismissed');
          panel.querySelector('a[href],button')?.focus();
          sync();
        }
      });
      item.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        e.preventDefault(); e.stopPropagation();
        trigger.focus();
        item.classList.add('a11y-menu-dismissed');
        sync();
      });
      sync();
    });
    document.querySelectorAll('a[role="button"]').forEach(button => {
      button.addEventListener('keydown', e => {
        if (e.key === ' ') { e.preventDefault(); button.click(); }
      });
    });
    document.querySelectorAll('.mobile-nav.st1 .sublinks').forEach(panel => {
      const syncPanel = () => { panel.inert = !panel.classList.contains('active'); };
      new MutationObserver(syncPanel).observe(panel, {attributes:true, attributeFilter:['class']});
      syncPanel();
    });
    const mobile = document.querySelector('.mobile-nav__wrapper');
    if (mobile) {
      mobile.id ||= 'a11y-mobile-navigation';
      let opener = null;
      document.querySelectorAll('.nav_toggle').forEach(button => {
        button.setAttribute('aria-controls', mobile.id);
        button.addEventListener('click', () => { opener = button; });
      });
      let wasOpen = false;
      const sync = () => {
        const open = html.classList.contains('mobile-nav-active');
        document.querySelectorAll('.nav_toggle').forEach(button => button.setAttribute('aria-expanded', String(open)));
        mobile.inert = !open;
        if (open && !wasOpen) mobile.querySelector('.close-menu')?.focus();
        if (!open && wasOpen && mobile.contains(document.activeElement)) opener?.focus();
        wasOpen = open;
      };
      new MutationObserver(sync).observe(html, {attributes:true, attributeFilter:['class']});
      mobile.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          e.preventDefault();
          mobile.querySelector('.close-menu')?.click();
        }
      });
      sync();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
})();
